import React from "react";
import { FluentAvatar } from "../../../../../components/FluentUI/Fluent-Avatar";
import PropTypes from "prop-types";

const Owner = ({ dataItem }) => {
  const ownerName = dataItem?.Owner?.Data || "";

  return (
    <>
      <FluentAvatar
        size={28}
        name={ownerName}
        className="task-member-user mr-2"
      />{" "}
      {ownerName}
    </>
  );
};

Owner.propTypes = {
  dataItem: PropTypes.shape({
    Owner: PropTypes.shape({
      Data: PropTypes.string,
    }),
  }),
};

Owner.defaultProps = {
  dataItem: null,
};

export default Owner;
